import { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimeRangePicker } from "@mui/x-date-pickers-pro/DateTimeRangePicker";
import { MultiInputDateTimeRangeField } from "@mui/x-date-pickers-pro/MultiInputDateTimeRangeField";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const DateTimeRangeFilter = ({ item, applyValue }) => {
  const [range, setRange] = useState([null, null]);

  const handleRangeChange = (newRange) => {
    setRange(newRange);
    
    applyValue({
      ...item,
      value: [
        newRange[0] ? newRange[0].format("YYYY-MM-DD HH:mm") : null,
        newRange[1] ? newRange[1].format("YYYY-MM-DD HH:mm") : null,
      ],
    });
  };

  useEffect(() => {
    if (item.value) {
      const [start, end] = item.value;
      setRange([
        start ? dayjs(start) : null,
        end ? dayjs(end) : null,
      ]);
    }
  }, [item.value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimeRangePicker
        value={range}
        onChange={handleRangeChange}
        ampm={false}
        slots={{
          field: MultiInputDateTimeRangeField,
        }}
        slotProps={{
          textField: ({ position }) => ({
            label: position === 'start' ? 'START DATE AND TIME' : 'END DATE AND TIME',
            size: 'small',
          }),
        }}
      />
    </LocalizationProvider>
  );
};

export default DateTimeRangeFilter;
